import Navigation from "@/components/landing/Navigation";
import Footer from "@/components/landing/Footer";

const ActiveAgingSOS = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-100 to-neutral-50 relative overflow-hidden">
      {/* Flowing background elements */}
      <div className="absolute top-0 right-0 w-1/2 h-[60%] bg-gradient-to-bl from-secondary/15 via-secondary/8 to-transparent blur-3xl" />
      <div className="absolute top-1/4 left-0 w-1/3 h-[50%] bg-gradient-to-r from-accent-teal/12 via-accent-teal/6 to-transparent blur-2xl" />
      <div className="absolute bottom-0 right-1/4 w-1/2 h-[40%] bg-gradient-to-t from-secondary/10 via-transparent to-transparent blur-3xl" />
      
      <Navigation />
      <main className="pt-32 pb-16 relative z-10">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-neutral-900 mb-6">
              Active Aging and SOS Buttons
            </h1>
            <p className="text-xl text-neutral-600 mb-8">
              Empowering seniors to live independently with confidence through comprehensive health monitoring and emergency response systems.
            </p>
            
            <div className="prose prose-lg max-w-none">
              <h2 className="text-2xl font-semibold text-neutral-800 mb-4">Independent Living Solutions</h2>
              <p className="text-neutral-600 mb-6">
                Our active aging platform combines health monitoring, emergency response, and wellness programs to help seniors maintain their independence while ensuring their safety and health are continuously monitored.
              </p>
              
              <h2 className="text-2xl font-semibold text-neutral-800 mb-4">Key Features</h2>
              <ul className="list-disc list-inside text-neutral-600 space-y-2 mb-6">
                <li>Wearable SOS emergency buttons with GPS tracking</li>
                <li>24/7 emergency monitoring and response</li>
                <li>Health vitals tracking and alerts</li>
                <li>Medication reminders and management</li>
                <li>Family and caregiver notifications</li>
                <li>Wellness and fitness programs</li>
              </ul>
              
              <h2 className="text-2xl font-semibold text-neutral-800 mb-4">Peace of Mind</h2>
              <p className="text-neutral-600">
                Our comprehensive solution provides peace of mind for both seniors and their families, enabling independent living while ensuring immediate help is available when needed through our advanced emergency response network.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ActiveAgingSOS;